module.exports = "pegasus/assets/email1-column-9.png";